const root = process.env.REACT_APP_API_GRAPHQL;
const bannerRoute =
  root +
  "?query={bannerHomeAyC(status: PUBLISHED){imagenFondo{urls} imagenFondoIpad{urls} imagenFondoIphone{urls} heroImage{urls} linea1{html} linea2{html} linea3{html} linea4{html} linea5{html} botonConsultar{urls} enlaceConsultar{url text} orden}}";

export default bannerRoute;
